import React, { type ComponentPropsWithRef } from 'react';
import { Spotlight } from '@atlaskit/onboarding';
import { useIsActiveSpotlightCard, type SpotlightCardKey } from '../../controllers';

type SpotlightProps = ComponentPropsWithRef<typeof Spotlight>;

export type Props = SpotlightProps & {
	/**
	 * Key to check if the card is active and should be displayed.
	 */
	cardKey: SpotlightCardKey;
};

/**
 * Renders a spotlight card if it is currently active.
 */
const SpotlightTourCard = ({ cardKey, ...spotlightProps }: Props) => {
	const [isActiveCard] = useIsActiveSpotlightCard(cardKey);

	return <>{isActiveCard && <Spotlight {...spotlightProps} />}</>;
};

export default SpotlightTourCard;
